export const getFlexTickets = 'getFlexTickets';
export const addFlexTickets = 'addFlexTickets';
export const addTodayProducts = 'addTodayProducts';
export const addProductToCart = 'addProductToCart';
export const removeProductFromCart = 'removeProductFromCart';
export const mergeLocalAndRemoteCart = 'mergeLocalAndRemoteCart';
export const restoreCart = 'restoreCart';
export const getTicketsAndCart = 'getTicketsAndCart';
export const getFixTicketsAndCart = 'getFixTicketsAndCart';
export const toggleFooter = 'toggleFooter';
export const toggleWeekDaysSwitch = 'toggleWeekDaysSwitch';
export const setDaysQuantity = 'setDaysQuantity';
export const setStartDate = 'setStartDate';
export const setEndtDate = 'setEndDate';
export const setSelectedFixEvent = 'setSelectedFixEvent';
export const getFixTickets = 'getFixTickets';
export const removeSelectedFixEvent = 'removeSelectedFixEvent';
export const setWeekdayOnly = 'setWeekdayOnly';
export const getCartPasses = 'getCartPasses';
export const getStockDates = 'getStockDates';
export const setStockDates = 'setStockDates';



// WEBPACK FOOTER //
// ./src/store/action-types.js